// extracted by css-extract-rspack-plugin
export default {"detailsBox":"lB5vjeeZDYjq6dNw","section":"iJdh8siAAsQM7zAM","sql":"J0yoUNc2waMmRBhQ"};